import { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Box, Typography, Svg, Button, useThemeValue } from '@altermaind/web/ui';
import { Routes } from '@/_shared/constants';
import { convertSizeToNumber } from '@/_shared/helpers';
import { useDialog, usePlatform } from '@/_shared/hooks';

export const DialogConfirmExitFromQuiz: FC = () => {
  const t = useTranslations('quiz.confirmExitFromQuizDialog');
  const navigate = useNavigate();
  const { closeDialog, Dialog, isOpen } = useDialog('confirmExitFromQuizDialog');
  const gapL = convertSizeToNumber(`${useThemeValue('sizes', 'l')}`);
  const { isAdmin } = usePlatform();

  const onExitConfirm = useCallback(() => {
    closeDialog();
    navigate(Routes.TrainingHardSkills);
  }, [closeDialog, navigate]);

  return (
    <Dialog maxWidth='700px' open={isOpen} title={undefined} onClose={closeDialog} closeButton>
      <Box display='flex' mb='m' flexDirection='column' px='s'>
        <Svg name='info' size='xxl' />
      </Box>
      <Box display='flex' mx='l' flexDirection='column' px='s'>
        <Typography variant='h3' color='primary/text' textAlign='center'>
          {t('title')}
        </Typography>
      </Box>
      <Box display='flex' mt='s' flexDirection='column' px='s'>
        <Typography variant='p2/light' color='primary/text' textAlign='center'>
          {t(isAdmin ? 'adminDescription' : 'description')}
        </Typography>
      </Box>

      <Box
        display='flex'
        mx='l'
        flexDirection='row'
        px='s'
        style={{ gap: gapL }}
        justifyContent='center'
      >
        <Button
          variant='link/primary'
          onClick={closeDialog}
          mt='l'
          style={{ textDecoration: 'none' }}
        >
          <Svg name='close' fill='primary/text' size='s' mr='xs' />
          {t('cancel')}
        </Button>

        <Button variant='primary' onClick={onExitConfirm} mt='l'>
          {t('confirm')}
        </Button>
      </Box>
    </Dialog>
  );
};
